import { Clickable, Col, Divider, Icon, Row, Text } from 'components';

const ContentHeader = ({ SettingsComponent, text, closePanel }) => {
  return (
    <Col pos="sticky" bg="#fff" center top="0" zIndex={2}>
      <Row between center pad="12px 24px 0">
        <Row noFlex center>
          {closePanel && (
            <Clickable onClick={closePanel}>
              <Icon pad="0 24px 0 0" type="leftChevron" dimensions={12} />
            </Clickable>
          )}

          <Text h3>{text}</Text>
        </Row>

        {SettingsComponent && <SettingsComponent />}
      </Row>

      <Divider marg="12px 0 0" />
    </Col>
  );
};

export default ContentHeader;
